import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

export default class MobileColumnsSlider {
    constructor() {
        this.sliderInstances = new Map();
        this.sliderOptions = {
            modules: [Autoplay],
            slidesPerView: 1,
            spaceBetween: 10,
            createElements: true,
            centeredSlides: true,
            autoplay: false,
            loop: false,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    centeredSlides: false,
                },
            },
        };
        this.mediaQuery = window.matchMedia("(max-width: 768px)");
        this.handleResize(this.mediaQuery);
        this.mediaQuery.addEventListener("change", (e) => this.handleResize(e));
    }

    handleResize(e) {
        if (e.matches) {
            this.enableSliders();
        } else {
            this.disableSliders();
        }
    }

    enableSliders() {
        document
            .querySelectorAll(".is-style-slider-on-mobile")
            .forEach((sliderContainer) => {
                if (!this.sliderInstances.has(sliderContainer)) {
                    this.initSlider(sliderContainer);
                    this.initObserver(sliderContainer);
                }
            });
    }

    disableSliders() {
        this.sliderInstances.forEach((swiper, sliderContainer) => {
            swiper.destroy(true, true);
            this.sliderInstances.delete(sliderContainer);

            const wrapper = sliderContainer.querySelector(".swiper-wrapper");
            if (wrapper) {
                const slides = Array.from(wrapper.children);
                slides.forEach((slide) => {
                    slide.classList.remove("swiper-slide");
                    sliderContainer.appendChild(slide);
                });
                wrapper.remove();
            }
        });
    }

    initSlider(sliderContainer) {
        let wrapper = sliderContainer.querySelector(".swiper-wrapper");

        if (!wrapper) {
            wrapper = document.createElement("div");
            wrapper.classList.add("swiper-wrapper");
            const slides = sliderContainer.querySelectorAll(".wp-block-column");
            slides.forEach((slide) => {
                slide.classList.add("swiper-slide");
                wrapper.appendChild(slide);
            });
            sliderContainer.appendChild(wrapper);
        }

        const swiperInstance = new Swiper(sliderContainer, this.sliderOptions);
        this.sliderInstances.set(sliderContainer, swiperInstance);
    }

    initObserver(sliderContainer) {
        const slides = sliderContainer.querySelectorAll(".swiper-slide");
        if (!slides.length) return;

        const firstSlide = slides[0];
        const lastSlide = slides[slides.length - 1];

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.target === firstSlide) {
                    sliderContainer.classList.toggle(
                        "can-scroll-left",
                        !entry.isIntersecting
                    );
                }
                if (entry.target === lastSlide) {
                    sliderContainer.classList.toggle(
                        "can-scroll-right",
                        !entry.isIntersecting
                    );
                }
            });
        };

        const observerOptions = {
            root: sliderContainer,
            threshold: 1.0,
        };

        const observer = new IntersectionObserver(
            observerCallback,
            observerOptions
        );
        observer.observe(firstSlide);
        observer.observe(lastSlide);
    }
}
